import OrderOptimizerRailyDetailsHiddenDetailsCenterTablesTableColumn from "./types/order-optimizer-raily-details-hidden-details-center-tables-table-column";

const getColumns =
  (): OrderOptimizerRailyDetailsHiddenDetailsCenterTablesTableColumn[] => {
    const tableColumns: OrderOptimizerRailyDetailsHiddenDetailsCenterTablesTableColumn[] =
      [
        {
          header: "",
          title: "",
          accessor: "orders",
          colSpan: 7,
        },
        {
          header: "",
          title: "",
          accessor: "driver",
          colSpan: 3,
        },
      ];

    return tableColumns;
  };

const orderOptimizerRailyDetailsHiddenDetailsCenterTablesTableHelper = {
  getColumns,
};

export default orderOptimizerRailyDetailsHiddenDetailsCenterTablesTableHelper;
